/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Header_More_Actions_AriaInputs */

const nl_app_header_more_actions_aria = /** @type {(inputs: App_Header_More_Actions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer acties`)
};

/**

* @param {App_Header_More_Actions_AriaInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_header_more_actions_aria = /** @type {((inputs?: App_Header_More_Actions_AriaInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Header_More_Actions_AriaInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_header_more_actions_aria(inputs)
});
export { app_header_more_actions_aria as "app.header.more_actions_aria" }